import React, {useState, useEffect} from 'react'
import { connect } from 'react-redux';
// actions
import {checkFours, checkFives, createFives, createFours} from 'actions/opkCheckerCreator'
// reactstrap components
import {
  Button,
  Modal,
  
} from "reactstrap";
import Spinner from 'components/common/Spinner';

const CheckOpkModal = ({show, modalDismiss, fileID, getChecker,
    CheckerCreator : {check_fours, check_fives, loading, error}, 
     checkFours, checkFives, createFives, createFours, updateTable}) => {
    const [ShowModal, setShowModal] = useState(false)
    
    useEffect(() => {
        if (getChecker === "getCheckFour" ) {
            checkFours(fileID)
        } else if (getChecker === "getCheckFive" ) {
            checkFives(fileID)
        }
    }, [fileID, getChecker])

    const handleCreator = () =>  {
        if (getChecker === "getCheckFour" ) {
            createFours(fileID)
        } else if (getChecker === "getCheckFive" ) {
            createFives(fileID)
        }
    }



    return(
        <Modal isOpen={show}>
            {/* toggle={()=>modalDismiss()}> */}
            {(loading|| getChecker === "getImport") ? 
                <div className="modal-header">
                    {/* <button className="close" type="button" onClick={()=>modalDismiss()} >
                        <span>×</span>
                    </button> */}
                    <h5 className="modal-title text-center" id="exampleModalLabel" >
                        <Spinner /><br/> Ładowanie...            
                    </h5>
                </div>
                :
                <>
                <div className="modal-header">
                    <button className="close" type="button" onClick={()=>modalDismiss()} >
                        <span>×</span>
                    </button>
                    <h5 className="modal-title text-center" id="exampleModalLabel" >
                        Konta OPK
                    </h5>
                </div>
                {error?
                    <>
                    <div className="modal-body ">
                        Wystąpił błąd. Upewnij się, że analizowany plik jest poprawny.
                    </div>
                    <div className="modal-footer">
                        <div className="left-side">
                            <Button className="btn-link" color="default" type="button" onClick={() => modalDismiss()} >
                            Zamknij
                            </Button>
                        </div>
                    </div>
                    </>
                    :
                    <>
                    <div className="modal-body">
                        {getChecker === "getCheckFour" ? (check_fours.text):(check_fives.text)}
                    </div>
                    <div className="modal-footer">
                        {(getChecker === "getCheckFour"&&check_fours.brak)||(getChecker === "getCheckFive"&&check_fives.brak) ?  
                            <>
                                <div className="left-side">
                                    <Button className="btn-link" color="default" type="button" onClick={() => modalDismiss()} >
                                        Zamknij
                                    </Button>
                                </div>
                                <div className="divider" />
                            </> 
                            : 
                            <div className="left-side">
                                <Button className="btn-link" color="default" type="button" onClick={() => modalDismiss()} >
                                Zamknij
                                </Button>
                            </div>
                        }
                    </div>
                    </>
                }          
                </>
            }
        </Modal>
    )
}

const mapStateToProps = state => ({
    CheckerCreator: state.CheckerCreator,
})

export default connect(mapStateToProps , {checkFours, checkFives, createFives, createFours})(CheckOpkModal)
